module.exports = __webpack_public_path__ + "img/default_blog.21672d91.jpg";